import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserRole } from '../../../models/enums/user-role.enum';
import UserShiftItem from './UserShiftItem';
import { DateCalendarData } from '../../../services/backend/api/shifts/responses/monthly-calendar-response';

interface WeekShiftItemProps {
    dateData: DateCalendarData;
    formatFullDate: (date: string) => string;
    formatShiftCount: (count: number) => string;
    onGoToSpecificDate?: (date: string) => void;
}

const WeekShiftItem: React.FC<WeekShiftItemProps> = ({ 
    dateData, 
    formatFullDate, 
    formatShiftCount,
    onGoToSpecificDate 
}) => {
    const { t } = useTranslation();

    const goToDate = () => {
        console.log(dateData.date);
        if (onGoToSpecificDate) {
            onGoToSpecificDate(dateData.date);
        }
    }

    return (
        <div className="bg-[#2D2D2D] rounded-lg overflow-hidden">
            <div className="flex justify-between items-center p-2">
                <p className="text-base font-normal">
                    {formatFullDate(dateData.date)}
                    <span className="text-gray-400 ml-2 text-sm">
                        {" " + formatShiftCount(dateData.calendar.reduce((acc, curr) => acc + 1 + curr.operators.length, 0))}
                    </span>
                </p>
                <button 
                    className="text-gray-400"
                    onClick={goToDate}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                    </svg>
                </button>
            </div>
            <div className="max-h-[144px] overflow-y-auto">
                {dateData.calendar.map((calendarItem, calendarIndex: number) => (
                    <div className="border-b border-white" key={calendarIndex}>
                        {/* Supervisor */}
                        <UserShiftItem
                            firstName={calendarItem.supervisor.user.firstName}
                            lastName={calendarItem.supervisor.user.lastName}
                            userId={calendarItem.supervisor.user.userId}
                            userRole={UserRole.Supervisor}
                        />

                        {/* Operators */}
                        {calendarItem.operators.map((operator, operatorIndex) => (
                            <UserShiftItem
                                key={operatorIndex}
                                firstName={operator.user.firstName}
                                lastName={operator.user.lastName}
                                userId={operator.user.userId}
                                userRole={UserRole.Operator}
                            />
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default WeekShiftItem; 